/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type AggregatesListingAnalytics_listing$ref = any;
type AggregatesListingBreadcrumbs_listing$ref = any;
type AggregatesListingCard_listing$ref = any;
type AggregatesListingCharacteristics_listing$ref = any;
type AggregatesListingEnergyDiagnostics_listing$ref = any;
type AggregatesListingH1_listing$ref = any;
type AggregatesListingPriceCardContent_listing$ref = any;
type AggregatesListingPriceCard_listing$ref = any;
type AggregatesListingPropertyDetails_listing$ref = any;
type AggregatesListingStructuredData_listing$ref = any;
type aggregatesListingCampaignEnquiry_listing$ref = any;
type aggregatesListingMap_listing$ref = any;
export type CompositePropertyType = "APPT" | "BUILDING" | "COMMERCIAL" | "GASTRO" | "HOUSE" | "HOUSE_APPT" | "OTHER" | "PARK" | "PROP" | "ROOM";
export type OfferType = "buy" | "rent";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListing_listing$ref: FragmentReference;
declare export opaque type AggregatesListing_listing$fragmentType: AggregatesListing_listing$ref;
export type AggregatesListing_listing = {|
  +id: string,
  +encodedId: string,
  +isListingCampaign: boolean,
  +isIdxListing: boolean,
  +offlineSince: ?string,
  +slug: string,
  +listingLanguage: ?string,
  +title: ?string,
  +translatedTitle: ?string,
  +livingSurface: ?number,
  +landSurface: ?number,
  +computedSurface: ?number,
  +offerType: OfferType,
  +salePrice: ?number,
  +salePricePerLivingSurface: ?number,
  +salePricePerLandSurface: ?number,
  +grossRentMonthly: ?number,
  +grossRentM2yearly: ?number,
  +currency: ?string,
  +postcode: ?string,
  +route: ?string,
  +address: ?string,
  +streetNumber: ?string,
  +agencyId: ?string,
  +agencyName: ?string,
  +agencySlug: ?string,
  +agencyLogoUrl: ?string,
  +agencyRating: ?number,
  +agencyReviewsCount: ?number,
  +agencyContactPhoneNumber: ?string,
  +visitContactPerson: ?string,
  +visitContactPhoneNumber: ?string,
  +agencyReference: ?string,
  +lotReference: ?string,
  +images: $ReadOnlyArray<{|
    +bucketName: string,
    +fileName: string,
    +blurhash: ?string,
  |}>,
  +similarListings: $ReadOnlyArray<{|
    +id: string,
    +encodedId: string,
    +slug: string,
    +title: ?string,
    +offerType: OfferType,
    +currency: ?string,
    +salePrice: ?number,
    +grossRentMonthly: ?number,
    +constructionYear: ?number,
    +renovationYear: ?number,
    +livingSurface: ?number,
    +landSurface: ?number,
    +computedSurface: ?number,
    +numberOfRooms: ?number,
    +numberOfBathrooms: ?number,
    +numberOfParking: ?number,
    +propertyMainType: ?string,
    +propertyType: ?string,
    +compositePropertyType: CompositePropertyType,
    +portal: string,
    +agencyId: ?string,
    +agencyName: ?string,
    +route: ?string,
    +streetNumber: ?string,
    +postcode: ?string,
    +subLocality: ?string,
    +locality: ?string,
    +lat: ?number,
    +lng: ?number,
    +url: ?{|
      +url: string
    |},
    +$fragmentRefs: AggregatesListingCard_listing$ref,
  |}>,
  +numberOfRooms: ?number,
  +numberOfBathrooms: ?number,
  +numberOfParking: ?number,
  +propertyType: ?string,
  +propertyMainType: ?string,
  +compositePropertyType: CompositePropertyType,
  +portal: string,
  +constructionYear: ?number,
  +renovationYear: ?number,
  +url: ?{|
    +url: string,
    +originalDomain: string,
  |},
  +bookOnline: ?boolean,
  +urls: $ReadOnlyArray<{|
    +url: string,
    +originalDomain: string,
    +mergedListingId: string,
  |}>,
  +locality: ?string,
  +subLocality: ?string,
  +localityObject: ?{|
    +label: string,
    +slug: string,
    +canonicalPlace: ?{|
      +label: string,
      +slug: string,
    |},
  |},
  +municipalityObject: ?{|
    +label: string,
    +slug: string,
    +objectId: string,
  |},
  +stateObject: ?{|
    +label: string,
    +extra: ?{|
      +canton_code: ?string
    |},
  |},
  +lat: ?number,
  +lng: ?number,
  +description: ?string,
  +translatedDescription: ?string,
  +agencyReferences: $ReadOnlyArray<?string>,
  +similarListingsStats: {|
    +saleOffersCount: number,
    +rentOffersCount: number,
  |},
  +$fragmentRefs: AggregatesListingAnalytics_listing$ref & AggregatesListingStructuredData_listing$ref & aggregatesListingMap_listing$ref & aggregatesListingCampaignEnquiry_listing$ref & AggregatesListingBreadcrumbs_listing$ref & AggregatesListingPropertyDetails_listing$ref & AggregatesListingCharacteristics_listing$ref & AggregatesListingPriceCard_listing$ref & AggregatesListingPriceCardContent_listing$ref & AggregatesListingH1_listing$ref & AggregatesListingEnergyDiagnostics_listing$ref,
  +$refType: AggregatesListing_listing$ref,
|};
export type AggregatesListing_listing$data = AggregatesListing_listing;
export type AggregatesListing_listing$key = {
  +$data?: AggregatesListing_listing$data,
  +$fragmentRefs: AggregatesListing_listing$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "encodedId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "livingSurface",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "landSurface",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "computedSurface",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerType",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salePrice",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grossRentMonthly",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postcode",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "route",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "streetNumber",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agencyId",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agencyName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "constructionYear",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "renovationYear",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfRooms",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfBathrooms",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfParking",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyMainType",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyType",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "compositePropertyType",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "portal",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subLocality",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locality",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lat",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lng",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalDomain",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filters"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListing_listing",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingCampaign",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isIdxListing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offlineSince",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "listingLanguage",
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "translatedTitle",
      "storageKey": null
    },
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salePricePerLivingSurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salePricePerLandSurface",
      "storageKey": null
    },
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "grossRentM2yearly",
      "storageKey": null
    },
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencySlug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyLogoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyRating",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyReviewsCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyContactPhoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitContactPerson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitContactPhoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyReference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lotReference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "AggregatesListingImage",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bucketName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fileName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blurhash",
          "storageKey": null
        }
      ],
      "storageKey": "images(first:100)"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "count",
          "value": 4
        }
      ],
      "concreteType": "AggregatesListing",
      "kind": "LinkedField",
      "name": "similarListings",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v7/*: any*/),
        (v10/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/),
        (v21/*: any*/),
        (v22/*: any*/),
        (v23/*: any*/),
        (v24/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v11/*: any*/),
        (v25/*: any*/),
        (v26/*: any*/),
        (v27/*: any*/),
        (v28/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "filters",
              "variableName": "filters"
            }
          ],
          "concreteType": "ExternalUrl",
          "kind": "LinkedField",
          "name": "url",
          "plural": false,
          "selections": [
            (v29/*: any*/)
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AggregatesListingCard_listing"
        }
      ],
      "storageKey": "similarListings(count:4)"
    },
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v22/*: any*/),
    (v21/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ExternalUrl",
      "kind": "LinkedField",
      "name": "url",
      "plural": false,
      "selections": [
        (v29/*: any*/),
        (v30/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bookOnline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ExternalUrl",
      "kind": "LinkedField",
      "name": "urls",
      "plural": true,
      "selections": [
        (v29/*: any*/),
        (v30/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mergedListingId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v26/*: any*/),
    (v25/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Place",
      "kind": "LinkedField",
      "name": "localityObject",
      "plural": false,
      "selections": [
        (v31/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Place",
          "kind": "LinkedField",
          "name": "canonicalPlace",
          "plural": false,
          "selections": [
            (v31/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Place",
      "kind": "LinkedField",
      "name": "municipalityObject",
      "plural": false,
      "selections": [
        (v31/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "objectId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Place",
      "kind": "LinkedField",
      "name": "stateObject",
      "plural": false,
      "selections": [
        (v31/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "PlaceExtraType",
          "kind": "LinkedField",
          "name": "extra",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canton_code",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v27/*: any*/),
    (v28/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "translatedDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyReferences",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ListingsStats",
      "kind": "LinkedField",
      "name": "similarListingsStats",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "saleOffersCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rentOffersCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregatesListingAnalytics_listing"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregatesListingStructuredData_listing"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "aggregatesListingMap_listing"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "aggregatesListingCampaignEnquiry_listing"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregatesListingBreadcrumbs_listing"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregatesListingPropertyDetails_listing"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregatesListingCharacteristics_listing"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregatesListingPriceCard_listing"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregatesListingPriceCardContent_listing"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregatesListingH1_listing"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregatesListingEnergyDiagnostics_listing"
    }
  ],
  "type": "AggregatesListing",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b1c6c4bb5eef016ce8a4443d39f61d9f';

export default node;
